import styled from 'styled-components'

interface IVendorSettingsStyledProps {}

export const VendorSettingsStyled = styled.div<IVendorSettingsStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
